import { _t } from "app/i18n/i18n";
import useIsMobile from "lib/hooks/useIsMobile";
import React from "react";
import { Alert } from "react-bootstrap";
import { LoadingSpinner } from "lib/Spinner";
import ErrorBoundary from "lib/ErrorBoundary";
import { useFetchAnalystData } from "../analystDirectory/api/useFetchAnalystData";
import { AnalystProfileCard } from "./parts/AnalystProfileCard";
import { AnalystProfileTabs } from "./parts/AnalystProfileTabs";

export function AnalystProfile() {
  const [, isLoading, isError, , hits] = useFetchAnalystData();
  const isMobile = useIsMobile();
  const profile = hits[0];

  if (isLoading) return <LoadingSpinner />;
  if (!isLoading && !profile) return <Alert>{_t("Sorry the requested profile cannot be found.")}</Alert>;
  if (isError) return <Alert>{_t("Sorry this data is not currently available, please try again later.")}</Alert>;

  return (
    <ErrorBoundary>
      <section>
        <AnalystProfileCard profile={profile} />
        <AnalystProfileTabs profile={profile} isMobile={isMobile} />
      </section>
    </ErrorBoundary>
  );
}
